import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import CGVAcceptanceModal from "@/components/CGVAcceptanceModal";

export default function ProtectedRoute({ children }) {
  const { user, loading, legalVersion } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app">
        <div className="flex items-center gap-3 text-secondary-text">
          <div className="spinner" />
          <span>Chargement…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  // CGV — modal bloquant si la version acceptée diffère de la version courante
  // (couvre 1ère connexion ET re-validation suite à un bump de LEGAL_VERSION).
  const acceptedVersion = user.legal_accepted_version || "";
  const needsAcceptance = legalVersion && acceptedVersion !== legalVersion;
  return (
    <>
      {children}
      {needsAcceptance && (
        <CGVAcceptanceModal currentVersion={legalVersion} acceptedVersion={acceptedVersion} />
      )}
    </>
  );
}
